import React from 'react';
import { 
  Cloud, 
  Globe, 
  Server, 
  Container, 
  Zap,
  HelpCircle
} from 'lucide-react';

interface PlatformIconProps {
  platform: string;
  className?: string;
}

const PlatformIcon: React.FC<PlatformIconProps> = ({ platform, className = "w-5 h-5" }) => {
  const platformLower = platform?.toLowerCase() || '';

  const getIcon = () => {
    switch (platformLower) {
      case 'aws':
      case 'amazon':
        return <Cloud className={`${className} text-orange-500`} />;
      case 'vercel':
        return <Zap className={`${className} text-black dark:text-white`} />;
      case 'netlify':
        return <Globe className={`${className} text-teal-500`} />;
      case 'docker':
        return <Container className={`${className} text-blue-500`} />;
      case 'heroku':
        return <Server className={`${className} text-purple-500`} />;
      case 'digitalocean':
        return <Cloud className={`${className} text-blue-600`} />;
      case 'gcp':
      case 'google':
        return <Cloud className={`${className} text-blue-400`} />;
      case 'azure':
      case 'microsoft':
        return <Cloud className={`${className} text-blue-700`} />;
      default:
        return <HelpCircle className={`${className} text-gray-500`} />;
    }
  };

  return (
    <div className="inline-flex items-center justify-center" title={`Platform: ${platform}`}>
      {getIcon()}
    </div>
  );
};

export default PlatformIcon;
